import { Icon } from "@oysterhr/ui"
import classNames from "classnames"
import { forwardRef, useCallback, useMemo } from "react"
import { useTranslation } from "react-i18next"

type BadgeButtonProps = {
  isOpen: boolean
  isInactive: boolean
  onClick: () => void
  isDisabled: boolean
}

export const BadgeButton = forwardRef<HTMLButtonElement, BadgeButtonProps>(
  ({ isOpen, isInactive, onClick, isDisabled }, ref) => {
    const [t] = useTranslation("staff_interface/TabProcessOverview")

    const styles = useMemo(() => {
      if (isInactive) {
        return {
          bg: "bg-warning-lighten-100",
          text: "text-warning-darken-100",
        }
      } else {
        return {
          bg: "bg-success-lighten-100",
          text: "text-success-darken-100",
        }
      }
    }, [isInactive])

    const handleClick = useCallback(() => {
      if (isDisabled) return

      onClick()
    }, [isDisabled, onClick])

    return (
      <button
        disabled={isDisabled}
        ref={ref}
        onClick={handleClick}
        className={classNames(
          "flex flex-row items-center space-x-1.5 rounded-full px-2 py-1",
          styles.bg,
        )}
      >
        <span className={classNames("text-sm", styles.text)}>
          {isInactive ? t("processSettings.form.inactive") : t("processSettings.form.active")}
        </span>
        {!isDisabled && (
          <Icon name={isOpen ? "ChevronUp" : "ChevronDown"} className={styles.text} />
        )}
      </button>
    )
  },
)
